import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData,
} from './utils';
import { PixelsVideoEvent } from '../../constants/Video';

const getPBJS = () => {
    // let i = 0;
    return () => {
      // need to change for indy and everything else
      // if (i === 0) {
      //   i++;
      //   return [window.pbjs, 'hero_player'];
      // }
      return [window.pixelsbjs, 'video1'];
    };
};

export const highestCPM = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
      metricsLog(`Highest CPM: init`);
   const adImpression$ = sub.pipe(
    filter(([type]) => type === PixelsVideoEvent.AD_IMPRESSION),
    map(getPBJS()),
    filter(([prebid]) => Boolean(prebid)),
    map(([prebid, adUnit]: any): number[] => {
      return prebid.getBidResponsesForAdUnitCode(adUnit).bids
        .map(({ cpm }: { cpm: number}) => cpm)
        .sort((a: number, b: number) => a - b);
    }),
   map((arr) => arr.length > 0 ? arr[arr.length - 1] : 0),
  );

  adImpression$.subscribe((cpm) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    metricsLog(`Highest CPM: ${cpm}`);

    setData(storageKey, {
      ...data,
      ad_cpm: {
        value: cpm > 0 ? cpm : null,
      }
    });
  });
};
